export default "__VITE_ASSET__Fbf9PhnK__"